import {login, passwordlogin,logout,loginauth, getInfo,auth} from '../request/api'
import {getToken, setToken, removeToken} from '../request/toekn'
import Cookies from 'js-cookie'
export default {
    // 验证码登录
    Login({commit}, userInfo) {
        return new Promise((resolve, reject) => {
            login(userInfo).then(response => {
                    if (response.data.code == 1) {
                        let jian ='token';
                        let zhi =  response.data.data.token;
                        let isrember=Lockr.get('isRemember')?Lockr.get('isRemember'):false;
                        if (isrember){ Cookies.set(jian, zhi,{expires:7});}
                        else{ Cookies.set(jian, zhi);}
                        setToken(jian);
                        let url='/v1/member/login/get_chat';
                        auth(url).then(res=>{
                            if (res.data.code==1){
                                let chat_user = res.data.data.chat_user;
                                let chat_token = res.data.data.chat_token;
                                Cookies.set('chat_user',chat_user);
                                Cookies.set('chat_token',chat_token);
                            }
                        })
                        resolve();
                        //存储token信息
                    } else {
                        reject(response.data)
                    }
                }
            ).catch(error => {
                reject(error)
            })
        })
    },
    // 密码登录
    PassLogin({commit}, userInfo) {
        return new Promise((resolve, reject) => {
            passwordlogin(userInfo).then(response => {
                    if (response.data.code == 1) {
                        let jian ='token';
                        let zhi =  response.data.data.token;
                        let isrember=Lockr.get('isRemember')?Lockr.get('isRemember'):false;
                        if (isrember){ Cookies.set(jian, zhi,{expires:7});}
                        else{ Cookies.set(jian, zhi);}
                        setToken(jian);
                        let url='/v1/member/login/get_chat';
                        auth(url).then(res=>{
                            if (res.data.code==1){
                                let chat_user = res.data.data.chat_user;
                                let chat_token = res.data.data.chat_token;
                                Cookies.set('chat_user',chat_user);
                                Cookies.set('chat_token',chat_token);
                            }
                        })
                        resolve();
                        //存储token信息
                    } else {
                        reject(response.data)
                    }
                }
            ).catch(error => {
                reject(error)
            })
        })
    },
    // 登出
    LogOut({commit}) {
        return new Promise((resolve, reject) => {
            logout().then(response => {
                Cookies.remove(getToken());
                commit('SET_NAME', '');
                commit('SET_VIPTYPE', '');
                commit('SET_VIP_LOG', '');

                //判断是否可以续费
                commit('SET_PUHUIYUN', '');
                commit('SET_TID', '');
                commit('SET_TWID', '');
                Cookies.remove('cate');
                Cookies.remove('chat_user');
                Cookies.remove('chat_token');
                Lockr.rm('packing');
                Lockr.rm('transport');
                Lockr.rm('user');
                Lockr.rm('defaultrouter_trans');
                Lockr.rm('dynamic_tag');
                Lockr.rm('dynamic_tag1');
                Lockr.rm('dynamic_tag2');
                window.localStorage.clear();
                window.location.reload();
                removeToken()
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },
    // 获取个人信息
    GetInfo({commit, state}) {
        return new Promise((resolve, reject) => {
            getInfo().then(response => {
                if (response.data.code == 1) {
                    let jsons = response.data.data;
                    let avatar=jsons.url + jsons.headimg;
                    let companyname=jsons.comName;
                    // 保存用戶信息的值 示例
                    commit('SET_NAME', jsons.name);
                    commit('SET_AVA', avatar);
                    commit('SET_COM',companyname);

                    commit('SET_VIPTYPE', jsons.vip_type);
                    commit('SET_VIP_LOG', jsons.vip_log);
                    //判断是否可以续费
                    commit('SET_PUHUIYUN', jsons.puhuiyun_buy);
                    commit('SET_TID', jsons.t_id);
                    commit('SET_TWID', jsons.id);
                    resolve(response)
                } else {
                    reject(response);
                    return false;
                }
            }).catch(error => {
                reject(error)
            })
        })
    },
}